import { useCallback, useEffect, useMemo, useState } from "react";
import apiUser from "app/api/user";
import { DeviceType, ISessionData, LoginHisItem } from "../types";
import dayjs from "dayjs";
import DeviceDetector from "device-detector-js";
import { securitySessionsTableColsV2 } from "@housebets/housebets-x-package/lib/components/feature/settings";
import { IListTableCol } from "@housebets/housebets-x-package/lib/components/ui/tables/Table/types";

const deviceDetector = new DeviceDetector();

const mapDeviceType = (arr: ISessionData[]) => {
    return arr.map((item) => {
        const isOsX = item.deviceName.includes('OSX');

        return {
            ...item,
            deviceType: isOsX ? 'desktop' : deviceDetector.parse(item.deviceName).device?.type as DeviceType
        }
    })
}

export const useSecurityPanelData = () => {
    const [sessionData, setSessionData] = useState<ISessionData[]>([]);
    const [page, setPage] = useState(1)
    const [canLoadMore, setCanLoadMore] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const cols = useMemo<IListTableCol[]>(() => {
        return securitySessionsTableColsV2
    }, [])

    const getData = async () => {
        setIsLoading(true);

        try {
            const { status, data } = await apiUser.getLoginHistory(page, 10);
            if (status === 200 && data.code === 0) {
                const list = data?.data?.list || [];

                const res: ISessionData[] = list.map((v: LoginHisItem) => {
                    return {
                        deviceName: v.device,
                        location: v.country,
                        ip: v.loginIp,
                        time: dayjs(v.ctime).format("YYYY/MM/DD HH:mm:ss"),
                    };
                });

                setSessionData(prev => [...prev, ...mapDeviceType(res)]);
                setPage(prev => {
                    if (res.length === 10) {
                        return prev + 1
                    }

                    return prev;
                });
                setCanLoadMore(res.length === 10);
            }
        } finally {
            setIsLoading(false)
        }
    };

    const onLoadMore = useCallback(() => {
        getData();
    }, [page]);

    useEffect(() => {
        getData();
    }, []);

    return {
        sessionData,
        cols,
        isLoading,
        setPage,
        onLoadMore,
        canLoadMore
    }
}
